// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const starmie: PokeData = {
  "id": 121,
  "name": "starmie",
  "height": 11,
  "weight": 800,
  "base_experience": 182,
  "types": [
    PokeType.WATER,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "water-gun",
    "hydro-pump",
    "surf",
    "psybeam",
    "bubble-beam",
    "psychic",
    "recover",
    "harden",
    "minimize",
    "confuse-ray",
    "light-screen",
    "swift",
    "psywave",
    "rapid-spin",
    "cosmic-power",
    "brine",
    "power-gem",
    "spotlight"
  ],
  "moves": [
    "tackle",
    "hydro-pump",
    "bubble-beam",
    "psychic",
    "confuse-ray",
    "psywave",
    "brine",
    "psy-pulse",
    "bubble",
    "psy-ball",
    "rain-dance",
    "water-spout",
    "aqua-tail"
  ],
  "evolution_chain": {
    "id": 56,
    "item": null,
    "species": [
      {
        "name": "staryu",
        "order": 137,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "starmie",
        "order": 138,
        "types": [
          PokeType.WATER,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 120,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 101,
    "speed": 160,
    "ability_power": 139
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
